import api from './index';

/**
 * Submit a consultation request
 * @param {Object} data - Form data
 * @returns {Promise<Object>} Response data
 */
export const submitConsultation = async (data) => {
    try {
        const response = await api.post('/consultation/request', data);
        return response;
    } catch (error) {
        throw error;
    }
};
